import { c as _c } from "react/compiler-runtime";
import { useAnimation } from 'framer-motion';
import { useState } from 'react';
import { useInterval, useTimeout } from 'usehooks-ts';
export function useGradientAnimation() {
  const $ = _c(5);
  const controls = useAnimation();
  const [isGradientActive, setIsGradientActive] = useState(false);
  const [toggle, setToggle] = useState(true);
  let t0;
  if ($[0] !== controls) {
    t0 = () => {
      controls.start("gradient1");
      setIsGradientActive(true);
    };
    $[0] = controls;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const startGradientAnimation = t0;
  let t1;
  if ($[2] !== controls || $[3] !== toggle) {
    t1 = () => {
      controls.start(toggle ? "gradient2" : "gradient1");
      setToggle(!toggle);
    };
    $[2] = controls;
    $[3] = toggle;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const toggleGradient = t1;
  useTimeout(startGradientAnimation, 800);
  useInterval(toggleGradient, isGradientActive ? 1000 : null);
  return controls;
}